module.exports = __webpack_public_path__ + "media/images/lb/312-9d30ece6ed9dd15a048b55e264739fba.svg";